import { FieldArray, useFormikContext } from 'formik';
import { useParams, Link } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form, Input as AntInput, Button as AntButton, Select, Modal, Table, Tooltip, message,Upload } from 'antd';
import { useOrderCordSave, useOrderCordUpdate } from 'store/server/useOrder';
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal';
import { Input as FormikInput } from 'components/form/input';
import { Input as UIInput } from 'components/ui/input';
import { Button as UIButton } from 'components/ui/button';
import { toast } from 'components/ui/use-toast';
import { RotateCcw, X } from 'lucide-react';
import { RxCross1 } from "react-icons/rx";
import { SelectReferanceCode6 } from 'components/form/compobox/select-referance-code6';
import requests from 'service/api';
import { useAuth } from 'store/client/authStore'

const { Option } = Select;

export default function CordInstructions({ currentTab }) {
  const { values, setFieldValue } = useFormikContext();
  const { mutate: saveOrder, isPending } = useOrderCordSave();
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderCordUpdate();
  const { brand, orderNo, dept, subDept } = useParams();
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)
  const [valcx, setvalcx] = useState(false);

  const brandId = brand.split('_')[0];
  const fieldArrayPushRef = useRef(null);
  const { user } = useAuth()

  // Default initialization for `cordLabel`
  useEffect(() => {
    if ((!values.cordLabel || values.cordLabel.length === 0) && fieldArrayPushRef.current) {
      fieldArrayPushRef.current({
        customerOrderNo: '',
        customerOrderDetail: '',
        colorCode: '',
        referanceCode: '',
      });
    }
  }, [values.cordLabel]);
  const DrawerContent4 = () => {
    const [form4] = Form.useForm();
    const [isUploading, setIsUploading] = useState(false);
    const [uploadError, setUploadError] = useState(null);

    const handleFileUpload = async (values) => {
      const formData = new FormData();
      
      // Dosya kontrolü
      if (!values.file || values.file.length === 0) {
        message.error('Lütfen bir PDF dosyası seçin');
        return;
      }

      const file = values.file[0].originFileObj;
      const fileName = values.fileName;
      
      if (!fileName) {
        message.error('Lütfen bir dosya adı girin');
        return;
      }

      if (!values.widthmm) {
        message.error('Lütfen bir genişlik girin');
        return;
      }
      if (!values.heightmm) {
        message.error('Lütfen bir yükseklik girin');
        return;
      }

      formData.append('file', file);
      formData.append('type', 'cord');
      formData.append('name', fileName);
      formData.append('width', values.widthmm);
      formData.append('height', values.heightmm);


      setIsUploading(true);
      setUploadError(null);

      try {
        const response = await requests.order.convertPdfToSvg(formData);
        
        if (response.status === 200) {
          message.success('PDF başarıyla SVG\'ye dönüştürüldü');
          form4.resetFields();
          setvalcx(!valcx);
          setIsDisliModalVisible(false)
        }
      } catch (error) {
        console.error('Hata:', error);
        setUploadError('Dosya yüklenirken bir hata oluştu');
        message.error('Dosya yüklenirken bir hata oluştu');
      } finally {
        setIsUploading(false);
      }
    };

    return (
      <div>
        <Form
          form={form4}
          layout="vertical"
          onFinish={handleFileUpload}
        >
          <Form.Item
            label="Referans Kodu"
            name="fileName"
            rules={[{ required: true, message: 'Referans Kodu girin' }]}
          >
            <AntInput 
              placeholder="Dosya adını girin"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-2'>
          <Form.Item
            label="Width(Genişlik)mm"
            name="widthmm"
            rules={[{ required: true, message: 'Width(Genişlik)mm şeklinde girin' }]}
          >
            <AntInput 
              placeholder="Genişlik girin"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label="Height(Yükseklik)mm"
            name="heightmm"
            rules={[{ required: true, message: 'Height(Yükseklik)mm şeklinde girin' }]}
          >
            <AntInput 
              placeholder="Yükseklik girin"
              style={{ width: '100%' }}
            />
          </Form.Item>
          </div>
          <Form.Item
            label="PDF Dosyası"
            name="file"
            rules={[{ required: true, message: 'Lütfen bir PDF dosyası seçin' }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList;
            }}
          >
            <Upload
              beforeUpload={(file) => {
                // Dosya tipini kontrol et
                const isPDF = file.type === 'application/pdf';
                if (!isPDF) {
                  message.error('Sadece PDF dosyaları yükleyebilirsiniz!');
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              accept=".pdf"
              maxCount={1}
              listType="text"
            >
              <AntButton>PDF Seç</AntButton>
            </Upload>
          </Form.Item>

          <Form.Item>
            <AntButton
              type="primary"
              htmlType="submit"
              loading={isUploading}
              style={{ width: '100%' }}
            >
              {isUploading ? 'Yükleniyor...' : 'Referans Ekle (Lütfen tamamlanana kadar bekleyiniz)'}
            </AntButton>
          </Form.Item>

          {uploadError && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {uploadError}
            </div>
          )}
        </Form>
      </div>
    );
  };
  const handleSaveOrder = () => {
   
    const errors = []
    const filteredValuesxx = values.cordLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
  
    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`;
    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    const path = `${brand}/${dept}/${subDept}`;
    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    if(errors.length === 0)
    {
    saveOrder({ ...values, washingLabel: filteredValues, brand: brandId, department, path });
  }
  };
  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }

  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }
  const handleUpdateOrder = () => {
    const errors = []
    const filteredValuesxx = values.cordLabel.map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
  

    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    delete values.brandId;
    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    if(errors.length === 0)
    {
    updateOrder({ id: orderNo, body: { ...values, washingLabel: filteredValues, brand: brandId } });
    }
  };

  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };

    return (
      <div style={{ position: "relative" }}>
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
          suffixIcon={<span style={{ display: 'none' }}></span>}
        >
          {options.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <FieldArray name="cordLabel">
      {({ push, remove }) => {
        fieldArrayPushRef.current = push; // Reference the `push` function
        console.log("alll valuess",values)
        return (
          <div>
            {values.cordLabel.map((_, idx) => (
              <div className="grid grid-cols-2 gap-5 pb-5 relative" key={idx}>
                <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
                  <UIInput
                    label="Müşteri Sipariş No"
                    value={values.cordLabel[idx]?.customerOrderNo}
                    onChange={(e) => {
                      setFieldValue(`cordLabel[${idx}].customerOrderNo`, e.target.value);
                    }}
                  />
                  <FormikInput
                    label="Müşteri Sipariş Detayı"
                    name={`cordLabel[${idx}].customerOrderDetail`}
                    autoComplete="off"
                  />
                  <FormikInput
                    label="Renk Kodu"
                    name={`cordLabel[${idx}].colorCode`}
                    maxLength="3"
                    autoComplete="off"
                  />
          <DisliSayisiDetayModal
                  visible={isDisliModalVisible}
                  onCancel={handleDisliModalClose}
                  minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                  width={740}
                  title="Kemer Etiketi Referans Ekle"
                >
                  <DrawerContent4 />
                </DisliSayisiDetayModal>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    <div style={{ width: '75%' }}>
                      <SelectReferanceCode6 name={`cordLabel[${idx}].referanceCode`} other={valcx} />
                    </div>
                    {user.companyName === "Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi" && 
                      user.tierType === "ADMIN" && (
  <div style={{ width: '20%', overflow:'hidden', marginRight:0}}>
    <UIButton
      type="button"
      variant="blue"
      onClick={handleDisliModalOpen}
      style={{width:'100%'}}
    >
      Referans Ekle
    </UIButton>
  </div>
)}

            
                  </div>
                  <FormikInput
                    type="number"
                    label="Adet"
                    name={`cordLabel[${idx}].qauntity`}
                    autoComplete="off"
                  />
             
                </div>
                <div className="col-span-2 grid grid-cols-2 gap-x-5">
                  <div className="col-span-2">
                    {idx > 0 && (
                      <UIButton
                        variant="destructive"
                        onClick={() => remove(idx)}
                        className="absolute -right-40 top-0"
                      >
                        <X className="w-4 h-4 text-white" /> Renk Sil
                      </UIButton>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="flex items-center gap-x-5">
              {!orderNo && (
                <UIButton
                  type="submit"
                  variant="softgreen"
                  onClick={handleSaveOrder}
                  disabled={isPending}
                  className="w-full"
                >
                  {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Kaydet
                </UIButton>
              )}

              <UIButton
                type="button"
                onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
                disabled={isPending || isPendingUpdate}
                className="w-full"
                variant={orderNo ? 'softgreen' : undefined}
              >
                {(isPending || isPendingUpdate) && <RotateCcw className="animate-spin mr-2" size={16} />} {orderNo ? 'Güncelle' : "Artwork'e Git"}
              </UIButton>

              {orderNo && (
                <Link
                  to={`/siparisler/artwork/${orderNo}?tab=${5}`}
                  target="_blank"
                  className="w-full"
                >
                  <UIButton type="button" disabled={isPending} className="w-full">
                    {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Artwork'e Git
                  </UIButton>
                </Link>
              )}

              <UIButton
                type="button"
                variant="blue"
                onClick={() => {
                  push({
                    ...values.cordLabel[0],
                    colorCode: '',
                    sizeDefectivePercent: '',
 
                  });
                }}
                className="w-full"
              >
                Renk Ekle
              </UIButton>
            </div>
          </div>
        );
      }}
    </FieldArray>
  );
}
